// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base skeleton animation */
@keyframes skeleton-loading {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
}

.skeleton {
  background: linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%);
  background-size: 200px 100%;
  animation: skeleton-loading 1.5s infinite;
  display: inline-block;
}

/* Skeleton Source Card */
.skeleton-source-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.skeleton-card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.skeleton-title-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.skeleton-card-body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.skeleton-card-footer {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

/* Skeleton Filter Section */
.skeleton-filter-section {
  margin-bottom: 1.5rem;
}

.skeleton-filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.skeleton-filter-options {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.skeleton-filter-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
}

/* Skeleton Search Bar */
.skeleton-search-bar {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0;
  width: 600px;
  max-width: 100%;
}

.skeleton-search-input {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  background: #ffffff;
}

/* Skeleton Source Grid */
.skeleton-source-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
  padding: 1rem 0;
}

/* Skeleton Filter Sidebar */
.skeleton-filter-sidebar {
  width: 250px;
  padding: 1rem;
  border-right: 1px solid #e5e7eb;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .skeleton-source-grid {
    grid-template-columns: 1fr;
  }

  .skeleton-search-bar {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }

  .skeleton-filter-sidebar {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }
}

@media (min-width: 1024px) {
  .skeleton-source-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1280px) {
  .skeleton-source-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* Skeleton variants for different states */
.skeleton.pulse {
  animation: skeleton-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes skeleton-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Skeleton text variants */
.skeleton.text-xs {
  height: 0.75rem;
}

.skeleton.text-sm {
  height: 0.875rem;
}

.skeleton.text-base {
  height: 1rem;
}

.skeleton.text-lg {
  height: 1.125rem;
}

.skeleton.text-xl {
  height: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/loading/skeleton.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,yEAAyE;EACzE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;AACjC;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,2CAA2C;AAC3C;EACE,kEAAkE;AACpE;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* Base skeleton animation */\n@keyframes skeleton-loading {\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n}\n\n.skeleton {\n  background: linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%);\n  background-size: 200px 100%;\n  animation: skeleton-loading 1.5s infinite;\n  display: inline-block;\n}\n\n/* Skeleton Source Card */\n.skeleton-source-card {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.skeleton-card-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.skeleton-title-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.skeleton-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.skeleton-card-footer {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n/* Skeleton Filter Section */\n.skeleton-filter-section {\n  margin-bottom: 1.5rem;\n}\n\n.skeleton-filter-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.skeleton-filter-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.skeleton-filter-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem;\n}\n\n/* Skeleton Search Bar */\n.skeleton-search-bar {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin: 1rem 0;\n  width: 600px;\n  max-width: 100%;\n}\n\n.skeleton-search-input {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.375rem;\n  background: #ffffff;\n}\n\n/* Skeleton Source Grid */\n.skeleton-source-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1rem;\n  padding: 1rem 0;\n}\n\n/* Skeleton Filter Sidebar */\n.skeleton-filter-sidebar {\n  width: 250px;\n  padding: 1rem;\n  border-right: 1px solid #e5e7eb;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .skeleton-source-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .skeleton-search-bar {\n    width: 100%;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .skeleton-filter-sidebar {\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid #e5e7eb;\n  }\n}\n\n@media (min-width: 1024px) {\n  .skeleton-source-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (min-width: 1280px) {\n  .skeleton-source-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n/* Skeleton variants for different states */\n.skeleton.pulse {\n  animation: skeleton-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n@keyframes skeleton-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* Skeleton text variants */\n.skeleton.text-xs {\n  height: 0.75rem;\n}\n\n.skeleton.text-sm {\n  height: 0.875rem;\n}\n\n.skeleton.text-base {\n  height: 1rem;\n}\n\n.skeleton.text-lg {\n  height: 1.125rem;\n}\n\n.skeleton.text-xl {\n  height: 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
